const info =  {
    ZH: { //中文翻译
        mustSelect :"\u8BF7\u5148\u9009\u62E9\u4E00\u4E2A\u67E5\u8BE2\u7ED3\u679C",
        correctPage :"\u8BF7\u8F93\u5165\u6B63\u786E\u9875\u7801",
        searchMds :"\u67E5\u8BE2MDS",
        search :"\u67E5\u627E",
        accord :"\u6309\u7167",
        asName :"\u540D\u79F0",
        asEnName :"\u82F1\u6587\u540D\u79F0",
        casNum :"CAS\u7F16\u53F7",
        alias :"\u522B\u540D",
        gadsl :"GADSL",
        desc :"\u964D\u5E8F",
        einecs:"EC\u7F16\u53F7",
        asc :"\u5347\u5E8F",
        order :"\u6392\u5E8F",
        checkout :"\u67E5\u770B",
        confirm :"\u786E\u5B9A",
        newSearch :"\u65B0\u7684\u67E5\u627E",
        index :"\u5E8F\u53F7",
        finded :"\u67E5\u8BE2\u5230",
        count :"\u6761",
        show :"\u663E\u793A",
        page :"\u9875",
        reachSvhc:"REACH\u9AD8\u5173\u6CE8\u7269\u8D28",
        yes:"\u662F",
        no:"\u5426",
    },
    EN: { //英文翻译
        mustSelect :"Please select a query result first!",
        correctPage :"Please input the correct Page No.",
        searchMds :"Search MDS",
        search :"search",
        accord :"order by",
        asName :"Name",
        asEnName :"English Name",
        casNum :"CAS No.",
        alias :"Synonym",
        gadsl :"GADSL",
        desc :"Descending",
        asc :"Ascending",
        order :"Order",
        checkout :"View",
        confirm :"Apply",
        einecs:"EC-Index",
        newSearch :"New Search",
        index :"No.",
        finded :"Search for",
        count :"Item",
        show :"Display",
        page :"page",
        reachSvhc:"REACH-SVHC",
        yes:"YES",
        no:"NO",
    }
  }
  export default info //需要暴露出去
  